var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "audit-status-page",
    },
    [
      !_vm.currentExamInfo.id
        ? _c("div", { staticClass: "empty-wrap" }, [
            _c("i", {
              staticClass: "el-icon-document",
              staticStyle: { "font-size": "66px", color: "#c0c4cc" },
            }),
            _c("div", { staticStyle: { "margin-top": "20px" } }, [
              _vm._v("请先在“报名列表”中选择一场考试"),
            ]),
          ])
        : !_vm.registrationInfo || _vm.registrationInfo.submitStatus !== 1
        ? _c("div", { staticClass: "empty-wrap" }, [
            _c("i", {
              staticClass: "el-icon-document",
              staticStyle: { "font-size": "66px", color: "#c0c4cc" },
            }),
            _c("div", { staticStyle: { "margin-top": "20px" } }, [
              _vm._v(
                "您尚未提交“" +
                  _vm._s(_vm.currentExamInfo.name) +
                  "”的报名信息，暂无审核状态"
              ),
            ]),
          ])
        : [
            _c(
              "el-card",
              { staticClass: "info-card" },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-header",
                    attrs: { slot: "header" },
                    slot: "header",
                  },
                  [
                    _c("span", { staticClass: "exam-name" }, [
                      _vm._v(_vm._s(_vm.currentExamInfo.name)),
                    ]),
                    _c(
                      "el-tag",
                      {
                        staticClass: "overall-tag",
                        attrs: { type: _vm.overallTagType, size: "medium" },
                      },
                      [_vm._v(_vm._s(_vm.overallStatusText))]
                    ),
                  ],
                  1
                ),
                _c(
                  "el-descriptions",
                  { attrs: { column: 2, border: "" } },
                  [
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "提交时间" } },
                      [
                        _vm._v(
                          _vm._s(
                            _vm.formatDateTime(_vm.registrationInfo.submitTime)
                          )
                        ),
                      ]
                    ),
                    _c(
                      "el-descriptions-item",
                      { attrs: { label: "报名时间" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.formatDate(_vm.currentExamInfo.signStartDate)
                            ) +
                            " ~ " +
                            _vm._s(
                              _vm.formatDate(_vm.currentExamInfo.signEndDate)
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("el-card", { staticClass: "info-card" }, [
              _c(
                "div",
                {
                  staticClass: "card-header",
                  attrs: { slot: "header" },
                  slot: "header",
                },
                [_c("span", [_vm._v("审核进度")])]
              ),
              _c(
                "div",
                { staticClass: "stage-list" },
                _vm._l(_vm.auditStages, function (stage) {
                  return _c(
                    "div",
                    {
                      key: stage.key,
                      staticClass: "stage-card",
                      class: "is-" + stage.state,
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "stage-head" },
                        [
                          _c("i", {
                            staticClass: "stage-icon",
                            class: stage.icon,
                          }),
                          _c("span", { staticClass: "stage-name" }, [
                            _vm._v(_vm._s(stage.name)),
                          ]),
                          _c(
                            "el-tag",
                            {
                              staticClass: "stage-tag",
                              attrs: { size: "medium", type: stage.tagType },
                            },
                            [_vm._v(_vm._s(stage.statusText))]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "stage-body" }, [
                        stage.opinionRequired || stage.opinion
                          ? _c("p", { staticClass: "stage-opinion" }, [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(_vm._s(stage.opinionLabel)),
                              ]),
                              _vm._v(_vm._s(stage.opinion || "-") + " "),
                            ])
                          : _vm._e(),
                        stage.tip
                          ? _c("p", { staticClass: "stage-tip" }, [
                              _c("span", { staticClass: "tip-label" }, [
                                _vm._v("提示："),
                              ]),
                              _vm._v(_vm._s(stage.tip) + " "),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                0
              ),
              _vm.allAuditFinished
                ? _c("p", { staticClass: "all-done-tip" }, [
                    _c("i", { staticClass: "el-icon-circle-check" }),
                    _vm._v(" " + _vm._s(_vm.finishedTip) + " "),
                  ])
                : _vm._e(),
              _vm.showBackToSignUp
                ? _c(
                    "div",
                    { staticClass: "action-block" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary", size: "small" },
                          on: { click: _vm.goSignUp },
                        },
                        [_vm._v(" 返回考生报名信息页 ")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }